import { Smartphone, ListChecks, CalendarCheck, TrendingUp } from "lucide-react";

const BENEFITS = [
    {
        id: "smartphone-friendly",
        icon: Smartphone,
        title: "Smartphone-Friendly",
        text: "Complete assigned tasks using your smartphone.",
    },
    {
        id: "clear-requirements",
        icon: ListChecks,
        title: "Clear Requirements",
        text: "Understand the account requirements and work instructions before starting.",
    },
    {
        id: "weekly-payment-cycle",
        icon: CalendarCheck,
        title: "Weekly Payment Cycle",
        text: "Eligible payments are processed every 7 days.",
    },
    {
        id: "ongoing-opportunities",
        icon: TrendingUp,
        title: "Ongoing Opportunities",
        text: "Further work depends on performance and availability.",
    },
];

export default function Benefits() {
    return (
        <section
            data-testid="benefits-section"
            className="mx-auto w-full max-w-6xl px-4 pb-12 md:px-6 md:pb-16"
        >
            <h2
                data-testid="benefits-heading"
                className="font-heading text-center text-2xl font-bold tracking-tight text-white md:text-3xl"
            >
                Work <span className="text-[#D4AF37]">Benefits</span>
            </h2>
            <div className="mt-7 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
                {BENEFITS.map(({ id, icon: Icon, title, text }) => (
                    <div
                        key={id}
                        data-testid={`benefit-card-${id}`}
                        className="rounded-2xl border border-[#D4AF37]/25 bg-[#101010] p-6 transition-colors duration-200 hover:border-[#D4AF37]/50"
                    >
                        <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-[#D4AF37]/40 bg-[#050505]">
                            <Icon className="h-5 w-5 text-[#D4AF37]" strokeWidth={1.8} aria-hidden="true" />
                        </span>
                        <h3 className="font-heading mt-4 text-lg font-semibold text-white">
                            {title}
                        </h3>
                        <p className="mt-2 text-sm leading-relaxed text-[#B5B5B5]">{text}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
